import api from './apiConfig';

// `api` ha già `/v1` nel baseURL (config/env.js): qui i path vanno scritti senza.
const BASE_URL = '/usage/pages';

/**
 * Pagine elaborate dall'installazione (AUTO-213). Tutte letture, tutte riservate all'admin lato
 * backend: un 403 qui significa che la guardia di rotta è stata aggirata, non che manca un dato.
 *
 * Ogni funzione accetta un `signal`: al cambio rapido di periodo le richieste in volo vanno
 * annullate, altrimenti la risposta lenta del periodo precedente sovrascrive quella nuova.
 */
export const usageService = {
  getSummary: async (params, signal) => {
    const response = await api.get(`${BASE_URL}/summary`, { params, signal });
    return response.data;
  },

  getTimeseries: async (params, signal) => {
    const response = await api.get(`${BASE_URL}/timeseries`, { params, signal });
    return response.data;
  },

  getByCodexType: async (params, signal) => {
    const response = await api.get(`${BASE_URL}/byCodexType`, { params, signal });
    return response.data;
  },

  getDocuments: async (params, signal) => {
    const response = await api.get(`${BASE_URL}/documents`, { params, signal });
    return response.data;
  },
};

export default usageService;
